import {LreRecipient} from './lre-recipient';

export class LreSender extends LreRecipient {
  public billingTag: string;
  public tags: string[];


  constructor(customerID: string) {
    super();
    this.signerQuality = 'PROFESSIONAL';
    this.billingTag = customerID;
    this.tags = [
      'TEST',
      'API'
    ];
  }
  public override stringify(): string {
    this.address = this.address[0].split('\n');
    return JSON.stringify(this);
  }
  public override isValid(): boolean {
    return super.isValid()
    && this.billingTag  !== '';
  }
}
